var __rest = this && this.__rest || function (s, e) {
  var t = {};
  for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
import * as React from 'react';
const SvgRotateCw = _a => {
  var {
      size
    } = _a,
    props = __rest(_a, ["size"]);
  return React.createElement("svg", Object.assign({
    width: size || 24,
    height: size || 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: props.role,
    "aria-hidden": props['aria-hidden'] || true
  }, props), React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2467 8.26179V3.99825C21.2467 3.58404 21.5825 3.24825 21.9967 3.24825C22.4109 3.24825 22.7467 3.58404 22.7467 3.99825V9.99825C22.7467 10.3049 22.5627 10.5685 22.2991 10.6848C22.1954 10.7287 22.0951 10.7485 21.9947 10.7483H15.9967C15.5825 10.7483 15.2467 10.4125 15.2467 9.99825C15.2467 9.58404 15.5825 9.24825 15.9967 9.24825H20.1064L16.8362 6.16841C14.2386 3.5692 10.2351 3.00133 7.01716 4.77567C3.79924 6.55 2.14277 10.2387 2.9545 13.8226C3.76624 17.4065 6.85048 20.0215 10.5189 20.2361C14.1873 20.4507 17.5554 18.2132 18.7795 14.7484C18.9175 14.3579 19.3459 14.1531 19.7365 14.2911C20.1271 14.4291 20.3318 14.8575 20.1938 15.2481C18.7472 19.3429 14.7667 21.9872 10.4313 21.7336C6.09589 21.4799 2.45089 18.3895 1.49156 14.154C0.532232 9.91846 2.48988 5.55905 6.29288 3.46211C10.0959 1.36518 14.8273 2.03629 17.8808 5.09224L21.2467 8.26179Z",
    fill: props.color || 'currentColor'
  }));
};
export default SvgRotateCw;